import { Button, useToast } from '@eluve/components';
import {
  useAppointmentActivity,
  useAppointmentId,
  useSummary,
} from '@eluve/frontend-appointment-hooks';
import { useGetFilePdfUrl } from '@eluve/frontend-feature-appointment';
import { useAssignedTenantIdFromParams } from '@eluve/session-helpers';
import { FeatureFlaggedComponent } from '@eluve/smart-blocks';

export const AppointmentPDFOutputControls = () => {
  const toast = useToast();
  const tenantId = useAssignedTenantIdFromParams();
  const { isSummaryAvailable } = useSummary();
  const { isSummarizationInProgress } = useAppointmentActivity();

  const appointmentId = useAppointmentId();
  const handlePdf = useGetFilePdfUrl({
    tenantId,
    appointmentId,
    type: 'CHART',
  });

  const openPdf = async () => {
    const newTab = window.open('about:blank', '_blank');
    const response = await handlePdf();
    if (response.status === 201 && newTab) {
      newTab.location = response.body.pdfUrl;
    } else {
      toast.error('Failed to prepare PDF');
    }
  };

  if (isSummarizationInProgress || !isSummaryAvailable) {
    return null;
  }

  return (
    <FeatureFlaggedComponent flag="PDF_OUTPUT">
      <Button variant="outline" onClick={openPdf}>
        Preview PDF
      </Button>
    </FeatureFlaggedComponent>
  );
};
